import React from 'react';

function MailSidebar({ folders, activeFolder, onSelectFolder, unreadCount, onCompose }) {
    return (
        <aside className="mail-sidebar">
            <button className="mail-compose-btn" onClick={onCompose}>
                <span className="compose-icon">✏️</span>
                <span>Написать</span>
            </button>

            <nav className="mail-folders">
                {folders.map(folder => {
                    const isActive = folder.id === activeFolder;
                    const count = folder.id === 'inbox' ? unreadCount : folder.count;

                    return (
                        <button
                            key={folder.id}
                            className={`mail-folder-item ${isActive ? 'active' : ''}`}
                            onClick={() => onSelectFolder(folder.id)}
                        >
                            <span className="folder-icon">{folder.icon}</span>
                            <span className="folder-name">{folder.name}</span>
                            {count > 0 && (
                                <span className="folder-count">{count}</span>
                            )}
                        </button>
                    );
                })}
            </nav>
        </aside>
    );
}

export default MailSidebar;